import type { Meta, Link } from 'unhead/types'
import { useParsePublicUrls } from '~/composables/useParsePublicUrls'

export const useHeadConfigComposable = () => {
  const { parsePublicUrls } = useParsePublicUrls()

  const headMetaClean: Meta[] = [
    {
      name: 'robots',
      content: 'noindex, nofollow',
    },
  ]

  const headLinkClean: Link[] = [
    {
      rel: 'icon',
      type: 'image/png',
      href: parsePublicUrls(
        '/__nuxt-public/images/favicon-v7/favicon-96x96.png',
      ),
      sizes: '96x96',
    },
    {
      rel: 'icon',
      type: 'image/svg+xml',
      href: parsePublicUrls('/__nuxt-public/images/favicon-v7/favicon.svg'),
    },
    {
      rel: 'shortcut icon',
      href: parsePublicUrls('/__nuxt-public/images/favicon-v7/favicon.ico'),
    },
    {
      rel: 'apple-touch-icon',
      sizes: '180x180',
      href: parsePublicUrls(
        '/__nuxt-public/images/favicon-v7/apple-touch-icon.png',
      ),
    },
  ]

  const useHeadComposed = {
    link: headLinkClean,
    meta: headMetaClean,
  }

  useHead(useHeadComposed)
}
